// extracted by mini-css-extract-plugin
export default {"button":"skills_framework_button-module___button___a8b8133e"};